import React from 'react';

import useFabletics from '../../hooks/useFabletics';
import FableticsUpgradeControl from './FableticsUpgradeControl';
import FableticsUpgradeVersionOne from './FableticsUpgradeVersionOne';
import FableticsUpgradeVersionTwo from './FableticsUpgradeVersionTwo';

const variantMap = {
    control: FableticsUpgradeControl,
    version_one: FableticsUpgradeVersionOne,
    version_two: FableticsUpgradeVersionTwo,
};

// Variant-aware visual creative for the Fabletics upgrade flow. Caller (the
// popup that hosts this) decides whether to render this at all — the dispatcher
// just routes to the assigned variant. No CTA, no form — those belong to the
// popup. See ENG-2203 for the experiment behind the variant assignment.
const FableticsUpgradeCreative = () => {
    const { variant } = useFabletics();
    const VariantComponent = variantMap[variant] || FableticsUpgradeControl;
    return <VariantComponent />;
};

export default FableticsUpgradeCreative;
